import React from "react";
import { Link } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import { MarketingLink } from "./MarketingLink";

import "./MarketingChrome.css";

// Marketing-section links (home, how-it-works, privacy, terms) use MarketingLink
// so they navigate to the separate marketing site under the www/app split. Auth
// CTAs (login/sign-up/games) always stay app-relative.

/**
 * Top nav for marketing surfaces — cream paper with deep navy
 * brand lockup, editorial nav links, and a dark accent CTA. Per
 * Direction A in plans/dashboard-redesign/claude-design-source/
 * project/direction-a-landing.jsx.
 */
export const MarketingNav = () => {
    const { isAuthenticated } = useAuth();

    return (
        <header className="mkt-nav">
            <div className="mkt-nav-inner">
                <MarketingLink to="/" className="mkt-brand">
                    <img
                        src="/poker-ledger-logo-half.svg"
                        alt="Poker Ledger"
                        className="mkt-crest"
                    />
                    <span className="mkt-brand-rule" aria-hidden="true" />
                    <span className="mkt-tagline">Nothing left on the table</span>
                </MarketingLink>
                <nav className="mkt-nav-links">
                    <MarketingLink to="/how-it-works">How it works</MarketingLink>
                    {/* <MarketingLink to="/pricing">Pricing</MarketingLink> */}
                    {isAuthenticated ? (
                        <Link to="/games" className="mkt-cta">
                            Open ledger →
                        </Link>
                    ) : (
                        <>
                            <Link to="/login" className="mkt-nav-link">
                                Sign in
                            </Link>
                            <Link to="/sign-up" className="mkt-cta">
                                Start a free ledger →
                            </Link>
                        </>
                    )}
                </nav>
            </div>
        </header>
    );
};

/**
 * Marketing footer — quiet rule + editorial mono row.
 */
export const MarketingFooter = () => (
    <footer className="mkt-footer">
        <div className="mkt-footer-inner">
            <div className="mkt-footer-brand">
                <img
                    src="/poker-ledger-logo-half.svg"
                    alt="Poker Ledger"
                    className="mkt-footer-crest"
                />
                <span className="mkt-footer-est">est. ’24</span>
            </div>
            <div className="mkt-footer-meta">
                © {new Date().getFullYear()}{" "}
                <a href="https://www.rockygray.com">Gray Designs</a> ·{" "}
                <MarketingLink to="/privacy">Privacy</MarketingLink> ·{" "}
                <MarketingLink to="/terms">Terms</MarketingLink>
            </div>
            <div className="mkt-footer-eyebrow">Nothing left on the table</div>
        </div>
    </footer>
);
